export const getAgeInYears = (birthdate: Date): number => {
  const today = new Date();
  const birth = new Date(birthdate);

  let age = today.getFullYear() - birth.getFullYear();
  let months = today.getMonth() - birth.getMonth();
  const days = today.getDate() - birth.getDate();

  if (days < 0) {
    months--;
  }

  if (months < 0) {
    age--;
  }

  return age;
};
